import { render, staticRenderFns } from "./SideBarLeisurewear.vue?vue&type=template&id=8d90879e"
import script from "./SideBarLeisurewear.vue?vue&type=script&lang=js"
export * from "./SideBarLeisurewear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports